<template>
  <div class="bg-blue-100 m-3 text-left rounded">
    <pre class="line-numbers">
    <code class='language-python'>
      # Import the library
      from transmap import TransMAP

      # Initialize TransMAP Hub
      map = TransMAP("https://oak.cast.uark.edu/transmap-api")

      # Add this layer by its ID
      map.add_layer("{{id}}")

      # Explore the data within a dataframe
      map.layers["{{id}}}"].dataframe
    </code>
  </pre>
  </div>
</template>

<script>
import Prism from 'vue-prism-component'

export default {
  name: 'PythonExample',
  components: {
    Prism,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
